import { useCallback, useEffect, useState } from "react";
import approvalsService from "../api/services/approvalsService";
import { getSupportSocket } from "../api/services/supportSocket";
import { subscribeApprovalsPendingChanged } from "../utils/approvalsEvents";

export default function usePendingApprovalsCount(enabled = true) {
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const total = await approvalsService.getPendingCount();
      setCount(total);
    } catch {
      // Keep the last known count on transient failures.
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }

    refresh();

    const onChanged = (detail = {}) => {
      if (typeof detail.delta === "number") {
        setCount((prev) => Math.max(0, prev + detail.delta));
      }
      refresh();
    };

    const unsubscribe = subscribeApprovalsPendingChanged(onChanged);

    const socket = getSupportSocket();
    const onSocket = () => refresh();
    socket.on("approvalsPendingChanged", onSocket);

    const interval = window.setInterval(refresh, 30000);

    return () => {
      unsubscribe();
      socket.off("approvalsPendingChanged", onSocket);
      window.clearInterval(interval);
    };
  }, [enabled, refresh]);

  return count;
}
